import { render, staticRenderFns } from "./MapleBear.vue?vue&type=template&id=0204935f&scoped=true"
import script from "./MapleBear.vue?vue&type=script&lang=js"
export * from "./MapleBear.vue?vue&type=script&lang=js"
import style0 from "./MapleBear.vue?vue&type=style&index=0&id=0204935f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204935f",
  null
  
)

export default component.exports